module.exports = __webpack_public_path__ + "static/media/Twitter.69d7b9be.svg";